<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card elevation="2">
          <v-row justify="center">
            <v-col cols="12" lg="5">
              <img contain class="imagen" :src="member.photoUrl" />
              <v-card-title class="title justify-center">{{member.name}} {{member.title}}</v-card-title>
              <v-card-subtitle class="pb-0">
                {{titles[member.type]}}
                <br />
                <br />
              </v-card-subtitle>
            </v-col>

            <v-col cols="12" lg="7">
              <v-card-text class="text">
                <span v-html="member.description" v-if="!member.html">{{member.description}}</span>
                <span v-if="member.html">
                  <h3 class="btntext noBold">Awards and Honors:</h3>
                  <ul dense class="scroll">
                    <template v-for="(award,i) in member.awards.split('-')">
                      <li :key="i" avatar>
                        <p>{{award}}</p>
                      </li>
                    </template>
                  </ul>
                  <br />
                  <p class="noBold">
                    Contact Info
                    <a
                      href="mailto:yszhang@research.bwh.harvard.edu"
                    >yszhang@research.bwh.harvard.edu</a>.
                  </p>
                </span>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "TeamMembers",
  data() {
    return {
      titles: [
        "Principal Investigator",
        "Visiting Scholars",
        "Postdoctoral Research Fellows",
        "PhD Students",
        "Master Students",
        "Undergraduate Students"
      ],
      member: {}
    };
  },
  computed: {
    ...mapState(["loadingMembers"]),
    ...mapGetters(["alumniMembers", "getMember"])
  },
  mounted() {
    if (!this.alumniMembers.length) {
      this.$store.dispatch("cargarMembers").then(() => {
        this.member = this.getMember(this.$route.params.id);
      });
    } else {
      this.member = this.getMember(this.$route.params.id);
    }
  }
};
</script>

<style>
.titlePage {
  align-content: center;
  text-align: center;
  font-size: 2.5rem;
  text-transform: uppercase;
}
</style>

<style scoped>
.text {
  align-content: justify;
  text-align: justify;
  padding-left: 0;
  padding-right: 36px;
  font-size: 1rem;
  word-break: break-word;
}

.director {
  align-content: justify;
  text-align: justify;
  padding-left: 0;
  padding-right: 36px;
}

.scroll {
  overflow-y: scroll;
  max-height: 280px;
  margin-top: 12px;
}

.btn {
  margin-bottom: 12px;
}

@media only screen and (max-width: 1265px) {
  .imagen {
    border-radius: 3%;
    max-height: 280px;
    margin-top: 0 !important;
  }
  .text {
    padding-left: 12px;
    padding-right: 12px;
    word-break: break-word;
  }
}

.imagen {
  border-radius: 3%;
  max-height: 280px;
  margin-top: 1.4rem;
}

.btntext {
  color: gray;
  margin: 0;
  word-break: break-word;
}

.link {
  color: #b80b0b;

  text-decoration-line: none;
}

.noBold {
  font-weight: normal;
  margin-left: 12px;
}

.imgMargin {
  margin: 0;
  padding-bottom: 0;
}

.title {
  font-size: 1.2rem;
  font-weight: bold;
  word-break: break-word;
}

.div-margin {
  margin: 1rem 10rem 0rem 10rem;
}
</style>